import { DocsCard } from '@/components/cardsListAboutClinic/docsCard/DocsCard';
import PharmacyCard from './pharmacyCard/PharmacyCard';
import { ChiefDoctorCard } from '@/components';
import { SvgDocs } from '../icons';
import type { CardsListAboutClinicProps } from './CardsListAboutClinic.types';
import s from './cardListAboutClinic.module.scss';

export const CardsListAboutClinic = ({ aboutData }: CardsListAboutClinicProps) => {
  return (
    <div className={s.cards}>
      <ChiefDoctorCard aboutData={aboutData} />
      <PharmacyCard />
      <DocsCard title="Документы" icon={<SvgDocs />} />
    </div>
  );
};